import {
  initialState,
  Actions,
  State,
  DELETE_BULK_SESSION,
  DELETE_BULK_SESSION_SUCCESS,
  DELETE_BULK_SESSION_ERROR,
  RESET_DELETE_BULK_SESSION,
} from "../../types/session/delete-bulk";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_BULK_SESSION:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_BULK_SESSION_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_BULK_SESSION_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_BULK_SESSION:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
